// extracted by mini-css-extract-plugin
export default {"container":"Footnote--container--7S89n","icon":"Footnote--icon---CH-2","row":"Footnote--row--VEDLG"};